import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_SUBSCRIPTION_SAGA } from "../sagaTypes";
import { loaderAction, subscriptionFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getSubscriptionsSagaAction, getUserInfoSagaAction } from "../sagaActions";
import { SUBSCRIPTION_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/update_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateSubscription(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);
        formData.append('times', args.data.times);
        formData.append('type', args.data.type || '');
        formData.append('coach', args.data.coach || '');
        formData.append('constraint', args.data.constraint || '');
        formData.append('user', args.data.user);
        formData.append('note', args.data.note);
        formData.append('payment', args.data.payment);
        formData.append('discount', args.data.discount);
        formData.append('activation_date', args.data.activation_date);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Сбрасываем данные формы
            yield put(subscriptionFormAction(SUBSCRIPTION_FORM_INITIAL));

            // Если редактировали абонемент на странице пользователя
            if (currentUser.id) {
                // Обновляем данные пользователя (с абонементами)
                yield put(getUserInfoSagaAction({ id: currentUser.id }));
            }
            // Если редактировали абонемент на странице с абонементами
            else {
                // Запрашиваем изменённые абонементы
                yield put(getSubscriptionsSagaAction());
            }
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateSubscription() {
    yield takeLatest(UPDATE_SUBSCRIPTION_SAGA, workerUpdateSubscription);
}